<template>
    <mst_syounin_groups-form />
</template>

<script lang="ts">
import {defineComponent } from 'vue'
import MstSyouninGroupsForm from '@/components/master/syounin_group/Create.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'mst_syounin_groups-form': MstSyouninGroupsForm
    }
})
</script>
